<script setup lang="ts">
defineProps<{
    title: string;
    subTitle?: string;
    webappPlacement?: 'between' | 'auto';
}>();
const emit = defineEmits<{
    submit: [];
}>();
const { isWebApp } = useDevice();
const actionsRef = ref<HTMLDivElement>();
const focus = () => {
    if (!isWebApp.value) {
        setTimeout(() => {
            actionsRef.value?.scrollIntoView({
                behavior: 'smooth',
                inline: 'nearest',
                block: 'end',
            });
        }, 300);
    }
};
</script>

<template>
    <form
        onsubmit="return false;"
        :class="[
            'login-popup-step',
            { between: isWebApp ? webappPlacement === 'between' : false },
        ]"
        @submit="emit('submit')"
    >
        <div class="content">
            <div class="step-header">
                <mr-typography>
                    <mr-typography
                        size="display4"
                        weight="700"
                        color="var(--gray-800)"
                    >
                        {{ title }}
                    </mr-typography>
                    <mr-typography weight="500" color="var(--gray-800)">
                        {{ subTitle }}
                    </mr-typography>

                    <slot name="extra-header-item" />
                </mr-typography>
            </div>
            <div class="inputs-container">
                <slot name="inputs" :focus />
            </div>
        </div>
        <slot />
        <div ref="actionsRef" class="login-actions-wrapper">
            <slot name="actions" />
        </div>
    </form>
</template>

<style lang="scss" scoped>
.login-popup-step {
    display: flex;
    flex-direction: column;
    gap: 24px;
    &.between {
        justify-content: space-between;
        flex-grow: 1;
    }
    .content {
        display: flex;
        flex-direction: column;
        gap: 48px;

        .step-header {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }
        .inputs-container {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }
    }

    .login-actions-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        width: 100%;
    }
}
</style>
